/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockEventListUpdate
 */
export interface ShockEventListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    userFullName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    shockEventMotionStatus?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    vehicleGroupLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventListUpdate
     */
    shockProfileLabel?: boolean | null;
}

/**
 * Check if a given object implements the ShockEventListUpdate interface.
 */
export function instanceOfShockEventListUpdate(value: object): value is ShockEventListUpdate {
    return true;
}

export function ShockEventListUpdateFromJSON(json: any): ShockEventListUpdate {
    return ShockEventListUpdateFromJSONTyped(json, false);
}

export function ShockEventListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userFullName': json['userFullName'] == null ? undefined : json['userFullName'],
        'shockEventMotionStatus': json['shockEventMotionStatus'] == null ? undefined : json['shockEventMotionStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'] == null ? undefined : json['vehicleGroupLabel'],
        'shockProfileLabel': json['shockProfileLabel'] == null ? undefined : json['shockProfileLabel'],
    };
}

export function ShockEventListUpdateToJSON(json: any): ShockEventListUpdate {
    return ShockEventListUpdateToJSONTyped(json, false);
}

export function ShockEventListUpdateToJSONTyped(value?: ShockEventListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userFullName': value['userFullName'],
        'shockEventMotionStatus': value['shockEventMotionStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
        'shockProfileLabel': value['shockProfileLabel'],
    };
}

